import { FC } from 'react';
import { useTranslation } from "next-i18next";
import { useTheme } from '@mui/material/styles';

import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import MarkDown from '../../md/MarkDown';



interface IPolicySectionProps {
  content: string;
  locale: string;
}

const PolicySection: FC<IPolicySectionProps> = (props: IPolicySectionProps) => {
  const { content, locale } = props;
  const theme = useTheme();
  const { t } = useTranslation('policy');

  return (
    <Container maxWidth='lg' sx={{ mt: 4 }} >
      <Typography component='h1' variant='h1'>
        {t('PolicySection.title')}
      </Typography>
      <Typography component='p' variant='subtitle1' gutterBottom>
        {t('PolicySection.subtitle')}
      </Typography>
      <Divider sx={{ my: 2, borderColor: theme.palette.secondary.dark }} />
      <MarkDown content={content} locale={locale} />
    </Container>
  )
}

export default PolicySection;